import styled from '@emotion/styled';

export const SadaCases = styled.div``;
